import addHours from "date-fns/addHours";
import getMonth from "date-fns/getMonth";
import format from "date-fns/format";
import kebabCase from "lodash/kebabCase";
import styled from "styled-components";
import React from "react";
import { A } from "@upsolve/ui";

const CitationsList = ({ citations }) => (
  <StyledCitationsList>
    <ol>
      {citations.map((c) => (
        <li key={kebabCase(c.title)} id={`citation-${kebabCase(c.title)}`}>
          {(c.organizationName || c.authorName) && `${c.organizationName || c.authorName}.`} (
          {c.publishedAt
            ? format(
                new Date(c.publishedAt),
                getMonth(addHours(new Date(c.publishedAt), 12)) === 0 ? "yyyy" : "yyyy, MMMM"
              )
            : "n.d."}
          ). {c.title && `${c.title}.`} {c.publication && <i>{c.publication}.</i>}{" "}
          {c.url && (
            <>
              Retrieved{c.lastViewedAt ? ` ${format(new Date(c.lastViewedAt), "MMMM d, yyyy")}, ` : " "}from{" "}
              <A href={c.url} target="_blank" rel="noopener noreferrer">
                {c.url}
              </A>
            </>
          )}
        </li>
      ))}
    </ol>
  </StyledCitationsList>
);

const StyledCitationsList = styled.div`
  margin: 1em 0;
  word-break: break-all;
  li {
    font-size: 13px;
  }
`;

export default CitationsList;
